module.exports = require('./helpers/bundle-url').getBundleURL('licOR') + "logo.c51670a8.svg";